import { FileExclamationOutlined } from "@ant-design/icons";
import { Col, Typography, Card, Statistic } from "antd";

import { styles } from "../styles/dashboardStyles";
import { Dashboard } from "../type/dashboard";

const { Text } = Typography;

interface ClientDashboardProps {
  dashboard: Dashboard;
}

const ClientDashboardCards = ({ dashboard }: ClientDashboardProps) => {
  const cardStyles = {
    ...styles.card,
    margin: "10px 0",
    height: 200,
    borderRadius: "8px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
    border: "1px solid #f0f0f0",
    overflow: "hidden",
  };

  return (
    <>
      <Col xs={24} sm={12} lg={8} xl={6}>
        <Card
          //   hoverable
          size="small"
          title={
            <div style={{ display: "flex", alignItems: "center" }}>
              <FileExclamationOutlined
                style={{
                  fontSize: "18px",
                  color: "#ff4d4f",
                  marginRight: "8px",
                }}
              />
              <span>All Incomplete Files</span>
            </div>
          }
          style={cardStyles}
          className="dashboard-card"
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              padding: "16px",
            }}
          >
            <Statistic
              value={dashboard?.totalFileNotCompleted || 0}
              valueStyle={{
                color: "#1890ff",
                fontSize: "28px",
                fontWeight: "bold",
              }}
              prefix={<FileExclamationOutlined />}
            />
            <Text
              type="secondary"
              style={{
                fontSize: "14px",
                marginTop: "8px",
                textAlign: "center",
              }}
            >
              Files requiring attention
            </Text>
          </div>
        </Card>
      </Col>
    </>
  );
};

export default ClientDashboardCards;
